// Field validation and masking utilities

export const maskPhone = (phone) => {
  if (!phone) return '-';
  const p = String(phone).trim();
  if (p.length < 4) return p;
  return 'XXXXXX' + p.slice(-4);
};

export const maskAadhaar = (aadhaar) => {
  if (!aadhaar) return '-';
  const a = String(aadhaar).trim();
  if (a.length < 4) return a;
  return 'XXXXXXXX' + a.slice(-4);
};

export const validatePhone = (phone) => {
  const p = String(phone).replace(/\D/g, '');
  return p.length === 10 && /^[6-9]/.test(p);
};

export const validatePhoneMessage = (phone) => {
  const p = String(phone).replace(/\D/g, '');
  if (p.length !== 10) return 'मोबाइल नंबर 10 अंकों का होना चाहिए';
  if (!/^[6-9]/.test(p)) return 'मोबाइल नंबर 6, 7, 8 या 9 से शुरू होना चाहिए';
  return null;
};

export const validateAadhaar = (aadhaar) => {
  const a = String(aadhaar).replace(/\D/g, '');
  return a.length === 12;
};

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validateRequired = (value) => {
  return value && String(value).trim().length > 0;
};
